import actions from './actions';
import { createReducer } from '../../../../../helpers/reducer';
import { keyBy } from '../../../../../helpers/core';

const initState = {
  isPoolModalShown: false,
  isShowBookingUnlockModal: false,
  isBulkEditCheckinCheckoutModalShown: false,
  isAssignTalentToShiftModalShown: false,
  isEditShiftModalShown: false,
  isUpdateRatingsModalShown: false,
  isResolveHoursModalShown: false,
  isUndoNCNSModalShown: false,
  isChangeToWorkingModalShown: false,
  isRemoveMultidayWorkerModalShown: false,
  isAssignMultidayWorkerModalShown: false,
  undoNCNSAction: null,
  bookingType: null,
  shiftToEdit: null,
  selectedBookingId: null,
  poolBooking: null,
  step: 1,
  isEditBookingModalShown: false,
  isAddGigModalShown: false,
  search: {},
  unlockFormInfo: { confirm: false, details: '', unlockReasons: [] },
  bookingActionsDisabled: false,
  bookingTimeType: null,
};

function validate(/* attr, value */) {
  const error = '';

  return error;
}

function onClearStore() {
  return { ...initState };
}

function onDisableBookingActions(state, { payload }) {
  return { ...state, bookingActionsDisabled: payload };
}

function onShowPoolModal(state, { payload }) {
  return {
    ...state,
    isPoolModalShown: true,
    poolBooking: payload.booking,
  };
}

function onShowAssignTalentToShiftModal(state, { payload }) {
  const shiftToEdit = { ...payload };

  return {
    ...state,
    isAssignTalentToShiftModalShown: true,
    shiftToEdit,
  };
}

function onShowBulkEditCheckinCheckoutModal(state, { payload }) {
  const { bookingId } = payload;

  return {
    ...state,
    selectedBookingId: bookingId,
    isBulkEditCheckinCheckoutModalShown: true,
  };
}

function onCloseBulkEditCheckinCheckoutModal(state) {
  return {
    ...state,
    selectedBookingId: null,
    isBulkEditCheckinCheckoutModalShown: false,
  };
}

function getEditableBreakDuration(breaks) {
  if (!breaks || breaks.auto_deducted) {
    return '';
  }

  return breaks.duration || '';
}

function onShowEditShiftModal(state, { payload }) {
  const { shift, default_starts_at, default_finishes_at, bookingId } = payload;
  const editObject = {
    status: shift.status?.id,
    started_at: shift.started_at || default_starts_at,
    finished_at: shift.finished_at || default_finishes_at,
    approved_break_duration: getEditableBreakDuration(shift.breaks),
    client_rating: shift.client_rating?.score?.id,
    talent_rating: shift.talent_rating?.score?.id,
    payment_method: shift.payment || '',
  };

  const propsArray = Object.keys(editObject);
  const editForm = keyBy(
    propsArray,
    prop => prop,
    prop => ({
      name: prop,
      value: editObject[prop],
      error: validate(prop, editObject[prop]),
      touched: false,
    }),
  );

  return {
    ...state,
    isEditShiftModalShown: true,
    shiftToEdit: { ...editForm, id: shift.id, bookingId },
  };
}

function onShowUpdateRatingsModal(state, { payload }) {
  const { shift, bookingId } = payload;

  const editObject = {
    client_rating: shift.client_rating?.score?.id,
    talent_rating: shift.talent_rating?.score?.id,
  };

  const propsArray = Object.keys(editObject);
  const editForm = keyBy(
    propsArray,
    prop => prop,
    prop => ({
      name: prop,
      value: editObject[prop],
      error: validate(prop, editObject[prop]),
      touched: false,
    }),
  );

  return {
    ...state,
    isUpdateRatingsModalShown: true,
    shiftToEdit: { ...editForm, id: shift.id, bookingId, worker: shift.worker },
  };
}

function onShowResolveHoursModal(state, { payload }) {
  const { shift, bookingId } = payload;
  const editObject = {
    started_at: shift.started_at,
    finished_at: shift.finished_at,
  };

  const propsArray = Object.keys(editObject);
  const editForm = keyBy(
    propsArray,
    prop => prop,
    prop => ({
      name: prop,
      value: editObject[prop],
      error: validate(prop, editObject[prop]),
      touched: false,
    }),
  );

  return {
    ...state,
    isResolveHoursModalShown: true,
    shiftToEdit: { ...editForm, id: shift.id, bookingId },
  };
}

function onShowUndoNCNSModal(state, { payload }) {
  const { action, bookingType, shift, bookingId } = payload;

  return {
    ...state,
    isUndoNCNSModalShown: true,
    undoNCNSAction: action,
    bookingType,
    shiftToEdit: { id: shift.id, bookingId },
  };
}

function onCloseUndoNCNSModal(state) {
  return {
    ...state,
    isUndoNCNSModalShown: false,
    undoNCNSAction: null,
    bookingType: null,
    shiftToEdit: null,
  };
}

function onShowChangeToWorkingModal(state, { payload }) {
  const { action, bookingId, startedAt } = payload;
  const editObject = { started_at: startedAt };

  const propsArray = Object.keys(editObject);
  const editForm = keyBy(
    propsArray,
    prop => prop,
    prop => ({
      name: prop,
      value: editObject[prop],
      error: '',
      touched: false,
    }),
  );

  return {
    ...state,
    isChangeToWorkingModalShown: true,
    shiftToEdit: { ...editForm, action, bookingId },
  };
}

function onShowRemoveMultidayWorkerModal(state, { payload }) {
  const { action, bookingId } = payload;

  return {
    ...state,
    isRemoveMultidayWorkerModalShown: true,
    shiftToEdit: {
      ...action,
      bookingId,
    },
  };
}

function onShowAssignMultidayWorkerModal(state, { payload }) {
  return {
    ...state,
    isAssignMultidayWorkerModalShown: true,
    shiftToEdit: {
      ...payload.action,
    },
  };
}

function onClosePoolModal(state) {
  return {
    ...state,
    isPoolModalShown: false,
  };
}

function onCloseAssignTalentToShiftModal(state) {
  return {
    ...state,
    isAssignTalentToShiftModalShown: false,
    shiftToEdit: null,
  };
}

function onCloseEditShiftModal(state) {
  return {
    ...state,
    isEditShiftModalShown: false,
    shiftToEdit: null,
  };
}

function onCloseUpdateRatingsModal(state) {
  return {
    ...state,
    isUpdateRatingsModalShown: false,
    shiftToEdit: null,
  };
}

function onCloseResolveHoursModal(state) {
  return {
    ...state,
    isResolveHoursModalShown: false,
    shiftToEdit: null,
  };
}

function onCloseChangeToWorkingModal(state) {
  return {
    ...state,
    isChangeToWorkingModalShown: false,
    shiftToEdit: null,
  };
}

function onCloseRemoveMultidayWorkerModal(state) {
  return {
    ...state,
    isRemoveMultidayWorkerModalShown: false,
    shiftToEdit: null,
  };
}

function onCloseAssignMultidayWorkerModal(state) {
  return {
    ...state,
    isAssignMultidayWorkerModalShown: false,
    shiftToEdit: null,
  };
}

function onShowEditBookingModal(state, { payload }) {
  const { isEditBookingModalShown, selectedBookingId } = state;
  const { bookingId, bookingTimeType } = payload || {};

  return {
    ...state,
    isEditBookingModalShown: !isEditBookingModalShown,
    selectedBookingId: selectedBookingId === bookingId ? null : bookingId,
    bookingTimeType,
  };
}

function onNext(state) {
  return {
    ...state,
    step: 2,
  };
}

function onSearchChanged(state, { payload }) {
  const { id, search } = payload;

  return {
    ...state,
    search: { ...state.search, [id]: search },
  };
}

function onShowBookingUnlockModal(state, { payload }) {
  const { bookingId } = payload;

  return {
    ...state,
    selectedBookingId: bookingId,
    isShowBookingUnlockModal: true,
  };
}

function onCloseBookingUnlockModal(state) {
  return {
    ...state,
    selectedBookingId: null,
    isShowBookingUnlockModal: false,
  };
}

function onGetUnlockReasonsSuccess(state, payload) {
  const {
    payload: { reasons },
  } = payload;

  return {
    ...state,
    unlockFormInfo: {
      unlockReasons: reasons,
    },
  };
}

function onChangeUnlockReason(state, payload) {
  const { unlockFormInfo } = state;

  return {
    ...state,
    unlockFormInfo: {
      ...unlockFormInfo,
      selectedReason: payload.payload,
    },
  };
}

function onChangeUnlockDetails(state, payload) {
  const { unlockFormInfo } = state;

  return {
    ...state,
    unlockFormInfo: {
      ...unlockFormInfo,
      details: payload.payload,
    },
  };
}

function onChangeUnlockConfirm(state, payload) {
  const { unlockFormInfo } = state;

  return {
    ...state,
    unlockFormInfo: {
      ...unlockFormInfo,
      confirm: payload.payload,
    },
  };
}

export { validate };
export default function reducer(newActions = {}) {
  return createReducer(initState, {
    [actions.CLEAR_STORE]: onClearStore,
    [actions.SHOW_POOL_MODAL]: onShowPoolModal,
    [actions.CLOSE_POOL_MODAL]: onClosePoolModal,
    [actions.SHOW_ASSIGN_TALENT_TO_SHIFT_MODAL]: onShowAssignTalentToShiftModal,
    [actions.CLOSE_ASSIGN_TALENT_TO_SHIFT_MODAL]: onCloseAssignTalentToShiftModal,
    [actions.SHOW_EDIT_SHIFT_MODAL]: onShowEditShiftModal,
    [actions.SHOW_UPDATE_RATINGS_MODAL]: onShowUpdateRatingsModal,
    [actions.CLOSE_EDIT_SHIFT_MODAL]: onCloseEditShiftModal,
    [actions.CLOSE_UPDATE_RATINGS_MODAL]: onCloseUpdateRatingsModal,
    [actions.SHOW_RESOLVE_HOURS_MODAL]: onShowResolveHoursModal,
    [actions.CLOSE_RESOLVE_HOURS_MODAL]: onCloseResolveHoursModal,
    [actions.SHOW_UNDO_NCNS_MODAL]: onShowUndoNCNSModal,
    [actions.CLOSE_UNDO_NCNS_MODAL]: onCloseUndoNCNSModal,
    [actions.SHOW_CHANGE_TO_WORKING_MODAL]: onShowChangeToWorkingModal,
    [actions.CLOSE_CHANGE_TO_WORKING_MODAL]: onCloseChangeToWorkingModal,
    [actions.SHOW_REMOVE_MULTIDAY_WORKER_MODAL]: onShowRemoveMultidayWorkerModal,
    [actions.CLOSE_REMOVE_MULTIDAY_WORKER_MODAL]: onCloseRemoveMultidayWorkerModal,
    [actions.SHOW_ASSIGN_MULTIDAY_WORKER_MODAL]: onShowAssignMultidayWorkerModal,
    [actions.CLOSE_ASSIGN_MULTIDAY_WORKER_MODAL]: onCloseAssignMultidayWorkerModal,
    [actions.TOGGLE_EDIT_BOOKING_MODAL]: onShowEditBookingModal,
    [actions.SHOW_BULK_EDIT_CHECKIN_CHECKOUT_MODAL]: onShowBulkEditCheckinCheckoutModal,
    [actions.CLOSE_BULK_EDIT_CHECKIN_CHECKOUT_MODAL]: onCloseBulkEditCheckinCheckoutModal,
    [actions.NEXT]: onNext,
    [actions.SEARCH_CHANGED]: onSearchChanged,
    [actions.SHOW_BOOKING_UNLOCK_MODAL]: onShowBookingUnlockModal,
    [actions.CLOSE_BOOKING_UNLOCK_MODAL]: onCloseBookingUnlockModal,
    [actions.GET_UNLOCK_REASONS_SUCCESS]: onGetUnlockReasonsSuccess,
    [actions.CHANGE_UNLOCK_REASON]: onChangeUnlockReason,
    [actions.CHANGE_UNLOCK_DETAILS]: onChangeUnlockDetails,
    [actions.CHANGE_UNLOCK_CONFIRM]: onChangeUnlockConfirm,
    [actions.DISABLE_BOOKING_ACTIONS]: onDisableBookingActions,
    ...newActions,
  });
}
